import firebase from 'firebase/compat'
import { useDocumentData } from 'hooks/firebase'
import { IThread } from '.'

export const useThread = (uid: string, tid: string) =>
  useDocumentData<IThread>(
    firebase.firestore().collection('users').doc(uid).collection('threads').doc(tid)
  )
